<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-dialogbox">
            <div class='mcf-dialogbox-form'>
                <div class="mcf-dialogbox-header">
                    <label><i :class='setting.icon'></i> {{setting.title}}</label>
                    <span v-html="setting.message"></span>
                </div>
                <div class="mcf-dialogbox-buttons">
                    <ul>
                        <li v-for="bt of setting.buttons" :key="bt.label" @click="bt.fx">{{bt.label}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        setting:{}
    },
    data(){
        return {
            
        };
    },
    created() {
        
    },
    methods:{
        
    }
}
</script>